import { editableFields } from '@sstdev/lib_metadata-authoring';
import { http, database } from 'lib_ui-services';

// The server validates the complete use case and commits source, navigation and history together.
export default async function saveAuthoringSource(data, context) {
    const fields = editableFields[context.relation];
    const pick = record =>
        Object.fromEntries(fields.filter(key => record[key] !== undefined).map(key => [key, record[key]]));
    const result = await http.post('/api/metaui/useCase/authoring/save_source', {
        authoringVersionId: data.newRecord['metadata:useCaseDetail']._id,
        sourceRecordId: data.newRecord._id,
        original: pick(data.oldRecord),
        replacement: pick(data.newRecord)
    });
    try {
        const db = database.get();
        for (const [relation, records] of Object.entries(result.records || {})) {
            const refreshed = await db.bulkUpsert('metadata', relation, records);
            if (refreshed?.errors || refreshed?.failedIds?.length) {
                throw new Error(`Could not refresh metadata:${relation}.`);
            }
        }
    } catch (cause) {
        // The server already committed. Do not retry the save or run legacy write handlers.
        throw new Error(
            'Your changes were saved, but the local data could not be refreshed. Reload Metadata Creator before editing again.',
            { cause }
        );
    }
    const newRecord =
        result.records?.[context.relation]?.find(record => record._id === data.newRecord._id) || data.newRecord;
    return { ...data, newRecord, authoringCommitted: true, result };
}
